// Only MeteoTracker preferences; all other map layers retain their defaults.
export const MOBILE_WINDOWS = [6, 12, 24, 36];
export function readMobilePreferences(storage) {
    try {
        const saved = JSON.parse(storage.getItem('wsv2-meteotracker') || '{}');
        return { enabled: saved.enabled !== false, hours: MOBILE_WINDOWS.includes(saved.hours) ? saved.hours : 6 };
    } catch { return { enabled: true, hours: 6 }; }
}
export function saveMobilePreferences(storage, prefs) {
    try { storage.setItem('wsv2-meteotracker', JSON.stringify(prefs)); } catch {}
}
